import immerHandleActions from 'redux/utils/immerHandleActions';

import * as actions from './actions';

const initialState = () => ({
	loadingIndicatorVisible: false,
});

const reducer = {
	[actions.showLoadingIndicator]: () => ({
		loadingIndicatorVisible: true,
	}),
	[actions.hideLoadingIndicator]: () => ({
		loadingIndicatorVisible: false,
	}),
	'persist/REHYDRATE': () => {
		return {
			...initialState(),
		};
	},
};

export default immerHandleActions(reducer, initialState());
